export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7047540d398b217357c989ad2a6a51c78a28cf3545&name=pushAdClickData!'